export { default } from "./AgeRuleForm";
